export default __webpack_public_path__ + "static/media/aboutMobile.3d33be05.png";